/* eslint-disable quote-props */

/*
  If you need to make changes here, make sure to
  make the same changes in config/intl_address_form_config.json in config-cache
*/

export default {
  'default': [
    {
      'fieldName': 'name',
      'display': {
        'de': 'Name',
        'en': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'it': 'Nome',
        'jp': '名前',
      },
      'required': true,
    },
    {
      'fieldName': 'street_address',
      'display': {
        'de': 'Straße',
        'en': 'Street Address (Line 1)',
        'es': 'Dirección',
        'fr': 'Adresse postale',
        'it': 'Indirizzo',
        'jp': '番地',
      },
      'required': true,
    },
    {
      'fieldName': 'extended_address',
      'display': {
        'de': '',
        'en': 'Street Address (Line 2)',
        'es': '',
        'fr': '',
        'it': '',
        'jp': '',
      },
      'required': false,
    },
    {
      'fieldName': 'locality',
      'display': {
        'de': 'Stadt',
        'en': 'City',
        'es': 'Ciudad',
        'fr': 'Ville',
        'it': 'Città',
        'jp': '市',
      },
      'required': true,
    },
    {
      'fieldName': 'region',
      'display': {
        'de': 'Bundesland',
        'en': 'State',
        'es': 'Estado',
        'fr': 'État',
        'it': 'Stato',
        'jp': '州',
      },
      'required': true,
    },
    {
      'fieldName': 'postal_code',
      'display': {
        'de': 'Postleitzahl',
        'en': 'Zip code',
        'es': 'Código postal',
        'fr': 'Code postal',
        'it': 'Codice postale',
        'jp': '郵便番号',
      },
      'required': true,
    },
    {
      'fieldName': 'phone',
      'display': {
        'de': 'Telefonnummer',
        'en': 'Phone Number',
        'es': 'Numero de teléfono',
        'fr': 'Numéro de téléphone',
        'it': 'Numero di telefono',
        'jp': '電話番号',
      },
      'required': false,
    },
  ],
  'US': [
    {
      'fieldName': 'name',
      'display': {
        'de': 'Name',
        'en': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'it': 'Nome',
        'jp': '名前',
      },
      'required': true,
    },
    {
      'fieldName': 'street_address',
      'display': {
        'de': 'Straße',
        'en': 'Street Address (Line 1)',
        'es': 'Dirección',
        'fr': 'Adresse postale',
        'it': 'Indirizzo',
        'jp': '番地',
      },
      'required': true,
    },
    {
      'fieldName': 'extended_address',
      'display': {
        'de': '',
        'en': 'Street Address (Line 2)',
        'es': '',
        'fr': '',
        'it': '',
        'jp': '',
      },
      'required': false,
    },
    {
      'fieldName': 'locality',
      'display': {
        'de': 'Stadt',
        'en': 'City',
        'es': 'Ciudad',
        'fr': 'Ville',
        'it': 'Città',
        'jp': '市',
      },
      'required': true,
    },
    {
      'fieldName': 'region',
      'display': {
        'de': 'Bundesland',
        'en': 'State',
        'es': 'Estado',
        'fr': 'État',
        'it': 'Stato',
        'jp': '州',
      },
      'required': true,
    },
    {
      'fieldName': 'postal_code',
      'display': {
        'de': 'Postleitzahl',
        'en': 'Zip code',
        'es': 'Código postal',
        'fr': 'Code postal',
        'it': 'Codice postale',
        'jp': '郵便番号',
      },
      'required': true,
    },
    {
      'fieldName': 'phone',
      'display': {
        'de': 'Telefonnummer',
        'en': 'Phone Number',
        'es': 'Numero de teléfono',
        'fr': 'Numéro de téléphone',
        'it': 'Numero di telefono',
        'jp': '電話番号',
      },
      'required': false,
    },
  ],
  'GB': [
    {
      'fieldName': 'name',
      'display': {
        'de': 'Name',
        'en': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'it': 'Nome',
        'jp': '名前',
      },
      'required': true,
    },
    {
      'fieldName': 'street_address',
      'display': {
        'de': 'Straße',
        'en': 'Street Address',
        'es': 'Dirección',
        'fr': 'Adresse postale',
        'it': 'Indirizzo',
        'jp': '番地',
      },
      'required': true,
    },
    {
      'fieldName': 'extended_address',
      'display': {
        'de': '',
        'en': 'Street Address (Line 2)',
        'es': '',
        'fr': '',
        'it': '',
        'jp': '',
      },
      'required': false,
    },
    {
      'fieldName': 'locality',
      'display': {
        'de': 'Ort',
        'en': 'Town/City',
        'es': 'Ciudad',
        'fr': 'Ville',
        'it': 'Citta',
        'jp': '町',
      },
      'required': true,
    },
    {
      'fieldName': 'postal_code',
      'display': {
        'de': 'Postleitzahl',
        'en': 'Postcode',
        'es': 'Código postal',
        'fr': 'Code postal',
        'it': 'Codice postale',
        'jp': '郵便番号',
      },
      'required': true,
    },
    {
      'fieldName': 'phone',
      'display': {
        'de': 'Telefonnummer',
        'en': 'Phone Number',
        'es': 'Numero de teléfono',
        'fr': 'Numéro de téléphone',
        'it': 'Numero di telefono',
        'jp': '電話番号',
      },
      'required': false,
    },
  ],
  'CA': [
    {
      'fieldName': 'name',
      'display': {
        'de': 'Name',
        'en': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'it': 'Nome',
        'jp': '名前',
      },
      'required': true,
    },
    {
      'fieldName': 'street_address',
      'display': {
        'de': 'Straße',
        'en': 'Street Address (Line 1)',
        'es': 'Dirección',
        'fr': 'Adresse postale',
        'it': 'Indirizzo',
        'jp': '番地',
      },
      'required': true,
    },
    {
      'fieldName': 'extended_address',
      'display': {
        'de': '',
        'en': 'Street Address (Line 2)',
        'es': '',
        'fr': '',
        'it': '',
        'jp': '',
      },
      'required': false,
    },
    {
      'fieldName': 'locality',
      'display': {
        'de': 'Stadt',
        'en': 'City',
        'es': 'Ciudad',
        'fr': 'Ville',
        'it': 'Città',
        'jp': '市',
      },
      'required': true,
    },
    {
      'fieldName': 'region',
      'display': {
        'de': 'Provinz',
        'en': 'Province',
        'es': 'Provincia',
        'fr': 'Province',
        'it': 'Provincia',
        'jp': '県',
      },
      'required': true,
    },
    {
      'fieldName': 'postal_code',
      'display': {
        'de': 'Postleitzahl',
        'en': 'Postal Code',
        'es': 'Código postal',
        'fr': 'Code postal',
        'it': 'Codice postale',
        'jp': '郵便番号',
      },
      'required': true,
    },
    {
      'fieldName': 'phone',
      'display': {
        'de': 'Telefonnummer',
        'en': 'Phone Number',
        'es': 'Numero de teléfono',
        'fr': 'Numéro de téléphone',
        'it': 'Numero di telefono',
        'jp': '電話番号',
      },
      'required': false,
    },
  ],
  'FR': [
    {
      'fieldName': 'name',
      'display': {
        'de': 'Name',
        'en': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'it': 'Nome',
        'jp': '名前',
      },
      'required': true,
    },
    {
      'fieldName': 'street_address',
      'display': {
        'de': 'Straße',
        'en': 'Street Address (Line 1)',
        'es': 'Dirección',
        'fr': 'Adresse postale',
        'it': 'Indirizzo',
        'jp': '番地',
      },
      'required': true,
    },
    {
      'fieldName': 'extended_address',
      'display': {
        'de': '',
        'en': 'Street Address (Line 2)',
        'es': '',
        'fr': '',
        'it': '',
        'jp': '',
      },
      'required': false,
    },
    {
      'fieldName': 'postal_code',
      'display': {
        'de': 'Postleitzahl',
        'en': 'Postcode',
        'es': 'Código postal',
        'fr': 'Code postal',
        'it': 'Codice postale',
        'jp': '郵便番号',
      },
      'required': true,
    },
    {
      'fieldName': 'locality',
      'display': {
        'de': 'Stadt',
        'en': 'City',
        'es': 'Ciudad',
        'fr': 'Ville',
        'it': 'Città',
        'jp': '市',
      },
      'required': true,
    },
    {
      'fieldName': 'phone',
      'display': {
        'de': 'Telefonnummer',
        'en': 'Phone Number',
        'es': 'Numero de teléfono',
        'fr': 'Numéro de téléphone',
        'it': 'Numero di telefono',
        'jp': '電話番号',
      },
      'required': false,
    },
  ],
  'DE': [
    {
      'fieldName': 'name',
      'display': {
        'de': 'Name',
        'en': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'it': 'Nome',
        'jp': '名前',
      },
      'required': true,
    },
    {
      'fieldName': 'street_address',
      'display': {
        'de': 'Straße und Hausnummer',
        'en': 'Street Address (Line 1)',
        'es': 'Dirección',
        'fr': 'Adresse postale',
        'it': 'Indirizzo',
        'jp': '番地',
      },
      'required': true,
    },
    {
      'fieldName': 'extended_address',
      'display': {
        'de': '',
        'en': 'Street Address (Line 2)',
        'es': '',
        'fr': '',
        'it': '',
        'jp': '',
      },
      'required': false,
    },
    {
      'fieldName': 'postal_code',
      'display': {
        'de': 'PLZ',
        'en': 'PLZ / Postcode',
        'es': 'Código postal',
        'fr': 'Code postal',
        'it': 'Codice postale',
        'jp': '郵便番号',
      },
      'required': true,
    },
    {
      'fieldName': 'locality',
      'display': {
        'de': 'Ort',
        'en': 'Town',
        'es': 'Ciudad',
        'fr': 'Ville',
        'it': 'Citta',
        'jp': '町',
      },
      'required': true,
    },
    {
      'fieldName': 'phone',
      'display': {
        'de': 'Telefonnummer',
        'en': 'Phone Number',
        'es': 'Numero de teléfono',
        'fr': 'Numéro de téléphone',
        'it': 'Numero di telefono',
        'jp': '電話番号',
      },
      'required': false,
    },
  ],
  'AU': [
    {
      'fieldName': 'name',
      'display': {
        'de': 'Name',
        'en': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'it': 'Nome',
        'jp': '名前',
      },
      'required': true,
    },
    {
      'fieldName': 'street_address',
      'display': {
        'de': 'Straße',
        'en': 'Street Address (Line 1)',
        'es': 'Dirección',
        'fr': 'Adresse postale',
        'it': 'Indirizzo',
        'jp': '番地',
      },
      'required': true,
    },
    {
      'fieldName': 'extended_address',
      'display': {
        'de': '',
        'en': 'Street Address (Line 2)',
        'es': '',
        'fr': '',
        'it': '',
        'jp': '',
      },
      'required': false,
    },
    {
      'fieldName': 'locality',
      'display': {
        'de': 'Vorstadt',
        'en': 'Suburb',
        'es': 'Suburbio',
        'fr': 'Banlieue',
        'it': 'Sobborgo',
        'jp': '郊外',
      },
      'required': true,
    },
    {
      'fieldName': 'postal_code',
      'display': {
        'de': 'Postleitzahl',
        'en': 'Postcode',
        'es': 'Código postal',
        'fr': 'Code postal',
        'it': 'Codice postale',
        'jp': '郵便番号',
      },
      'required': true,
    },
    {
      'fieldName': 'region',
      'display': {
        'de': 'Bundesland',
        'en': 'State',
        'es': 'Estado',
        'fr': 'État',
        'it': 'Stato',
        'jp': '州',
      },
      'required': true,
    },
    {
      'fieldName': 'phone',
      'display': {
        'de': 'Telefonnummer',
        'en': 'Phone Number',
        'es': 'Numero de teléfono',
        'fr': 'Numéro de téléphone',
        'it': 'Numero di telefono',
        'jp': '電話番号',
      },
      'required': false,
    },
  ],
  'IT': [
    {
      'fieldName': 'name',
      'display': {
        'de': 'Name',
        'en': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'it': 'Nome',
        'jp': '名前',
      },
      'required': true,
    },
    {
      'fieldName': 'street_address',
      'display': {
        'de': 'Straße',
        'en': 'Street Address (Line 1)',
        'es': 'Dirección',
        'fr': 'Adresse postale',
        'it': 'Indirizzo',
        'jp': '番地',
      },
      'required': true,
    },
    {
      'fieldName': 'extended_address',
      'display': {
        'de': '',
        'en': 'Street Address (Line 2)',
        'es': '',
        'fr': '',
        'it': '',
        'jp': '',
      },
      'required': false,
    },
    {
      'fieldName': 'postal_code',
      'display': {
        'de': 'Postleitzahl',
        'en': 'CAP / Postcode',
        'es': 'Código postal',
        'fr': 'Code postal',
        'it': 'CAP',
        'jp': '郵便番号',
      },
      'required': true,
    },
    {
      'fieldName': 'locality',
      'display': {
        'de': 'Stadt',
        'en': 'City',
        'es': 'Ciudad',
        'fr': 'Ville',
        'it': 'Città',
        'jp': '市',
      },
      'required': true,
    },
    {
      'fieldName': 'region',
      'display': {
        'de': 'Provinz',
        'en': 'Province',
        'es': 'Provincia',
        'fr': 'Province',
        'it': 'Provincia',
        'jp': '県',
      },
      'required': true,
    },
    {
      'fieldName': 'phone',
      'display': {
        'de': 'Telefonnummer',
        'en': 'Phone Number',
        'es': 'Numero de teléfono',
        'fr': 'Numéro de téléphone',
        'it': 'Numero di telefono',
        'jp': '電話番号',
      },
      'required': false,
    },
  ],
  'ES': [
    {
      'fieldName': 'name',
      'display': {
        'de': 'Name',
        'en': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'it': 'Nome',
        'jp': '名前',
      },
      'required': true,
    },
    {
      'fieldName': 'street_address',
      'display': {
        'de': 'Straße',
        'en': 'Street Address (Line 1)',
        'es': 'Dirección',
        'fr': 'Adresse postale',
        'it': 'Indirizzo',
        'jp': '番地',
      },
      'required': true,
    },
    {
      'fieldName': 'extended_address',
      'display': {
        'de': '',
        'en': 'Street Address (Line 2)',
        'es': '',
        'fr': '',
        'it': '',
        'jp': '',
      },
      'required': false,
    },
    {
      'fieldName': 'postal_code',
      'display': {
        'de': 'Postleitzahl',
        'en': 'Postcode',
        'es': 'Código postal',
        'fr': 'Code postal',
        'it': 'Codice postale',
        'jp': '郵便番号',
      },
      'required': true,
    },
    {
      'fieldName': 'locality',
      'display': {
        'de': 'Ort',
        'en': 'Town',
        'es': 'Ciudad',
        'fr': 'Ville',
        'it': 'Citta',
        'jp': '町',
      },
      'required': true,
    },
    {
      'fieldName': 'region',
      'display': {
        'de': 'Provinz',
        'en': 'Province',
        'es': 'Provincia',
        'fr': 'Province',
        'it': 'Provincia',
        'jp': '県',
      },
      'required': true,
    },
    {
      'fieldName': 'phone',
      'display': {
        'de': 'Telefonnummer',
        'en': 'Phone Number',
        'es': 'Numero de teléfono',
        'fr': 'Numéro de téléphone',
        'it': 'Numero di telefono',
        'jp': '電話番号',
      },
      'required': false,
    },
  ],
  'NL': [
    {
      'fieldName': 'name',
      'display': {
        'de': 'Name',
        'en': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'it': 'Nome',
        'jp': '名前',
      },
      'required': true,
    },
    {
      'fieldName': 'street_address',
      'display': {
        'de': 'Straße',
        'en': 'Street Address (Line 1)',
        'es': 'Dirección',
        'fr': 'Adresse postale',
        'it': 'Indirizzo',
        'jp': '番地',
      },
      'required': true,
    },
    {
      'fieldName': 'extended_address',
      'display': {
        'de': '',
        'en': 'Street Address (Line 2)',
        'es': '',
        'fr': '',
        'it': '',
        'jp': '',
      },
      'required': false,
    },
    {
      'fieldName': 'postal_code',
      'display': {
        'de': 'Postleitzahl',
        'en': 'Postcode',
        'es': 'Código postal',
        'fr': 'Code postal',
        'it': 'Codice postale',
        'jp': '郵便番号',
      },
      'required': true,
    },
    {
      'fieldName': 'locality',
      'display': {
        'de': 'Stadt',
        'en': 'City',
        'es': 'Ciudad',
        'fr': 'Ville',
        'it': 'Città',
        'jp': '市',
      },
      'required': true,
    },
    {
      'fieldName': 'phone',
      'display': {
        'de': 'Telefonnummer',
        'en': 'Phone Number',
        'es': 'Numero de teléfono',
        'fr': 'Numéro de téléphone',
        'it': 'Numero di telefono',
        'jp': '電話番号',
      },
      'required': false,
    },
  ],
};



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/addresses/address_fields_config.ts